"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getFiltersDataSelector = void 0;

var _reselect = require("reselect");

var leaderboardStateSelector = function leaderboardStateSelector(leaderboardType) {
  return function (state) {
    return state.leaderboard[leaderboardType];
  };
};

var getFiltersSelector = function getFiltersSelector(leaderboardType) {
  return (0, _reselect.createSelector)(leaderboardStateSelector(leaderboardType), function (leaderboardState) {
    return leaderboardState.filters;
  });
};

var getFiltersDataSelector = function getFiltersDataSelector(leaderboardType) {
  return (0, _reselect.createSelector)(getFiltersSelector(leaderboardType), function (filters) {
    return filters.data;
  });
};

exports.getFiltersDataSelector = getFiltersDataSelector;
var _default = {
  getFiltersDataSelector: getFiltersDataSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map